import { createSlice } from '@reduxjs/toolkit';
import { REMEMBER_REHYDRATED } from 'redux-remember';
import appTypes from '../app/types';
import { actions as userActions } from '../user/reducer';
import { ENABLED_INTEGRATION_STATUS } from './constants';
const initialState = {
    accountCreditsTypes: [],
    totalCredits: 0,
    userPlanTotalCredits: 0,
    activeIntegrations: [],
    connectedIntegrations: [],
    isAccountIntegrationLoaded: false,
    intentTopics: [],
    isIntentTopicsLoaded: false,
};
const slice = createSlice({
    name: 'ACCOUNT',
    initialState,
    extraReducers(builder) {
        builder.addCase(appTypes.RESET, () => initialState);
        builder.addCase(userActions.loggedOut, () => initialState);
        // Cached lists show straight away; the loaded flags reset so integrations and intent topics still refetch.
        builder.addCase(REMEMBER_REHYDRATED, state => (Object.assign(Object.assign(Object.assign({}, initialState), state), { isAccountIntegrationLoaded: false, isIntentTopicsLoaded: false })));
    },
    reducers: {
        setTotalCredits(state, { payload }) {
            state.totalCredits = payload;
        },
        setAccountCreditsTypes(state, { payload }) {
            state.accountCreditsTypes = payload;
        },
        setPlanCredits(state, { payload }) {
            state.totalCredits = payload.totalCredits;
            state.userPlanTotalCredits = payload.userPlanTotalCredits;
        },
        /** `undefined` is a response with no body: the lists stay as they are, but the fetch still counts as done. */
        setIntegrations(state, { payload }) {
            if (payload) {
                state.activeIntegrations = payload.map(item => { var _a; return (_a = item.integration) === null || _a === void 0 ? void 0 : _a.name; }).filter(Boolean);
                state.connectedIntegrations = payload
                    .filter(item => item.isUserConnected && item.status === ENABLED_INTEGRATION_STATUS)
                    .map(item => { var _a; return (_a = item.integration) === null || _a === void 0 ? void 0 : _a.name; })
                    .filter(Boolean);
            }
            state.isAccountIntegrationLoaded = true;
        },
        /** `undefined` is a failed fetch: the list stays as it is, but the fetch still counts as done. */
        setIntentTopics(state, { payload }) {
            if (payload) {
                state.intentTopics = payload;
            }
            state.isIntentTopicsLoaded = true;
        },
    },
});
export const { reducer, actions } = slice;
export default reducer;
